import { SET_TEAM_USER, SET_CHAT_ROOM } from "../actions/type.action";

const initialState = {
  team:[],
  name:'',
  room:''
};

export const matterMostReducer = (state = initialState, action) => {
  // console.count('snack action');
  switch (action.type) {
  case SET_TEAM_USER:
    return {
      ...state,
      team:action.payload
    };
  case SET_CHAT_ROOM:
    return {
      ...state,
      room:action.payload.room,
      name:action.payload.name,
    };  

  default:
    return state;
  }
};
